import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeOutstandingWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.outstanding",
  name: "Outstanding balance",
  description: "Outstanding balance for the selected dashboard period.",
  apps: [
    "home",
    "finance",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "residual_amount",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Outstanding",
    subtext: "",
    icon: "money",
    color: "warning",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$28,200",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
